export enum LandPageView {
  ATLAS = 'atlas',
  GRID = 'grid'
}
